import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import InstituteService from "../../services/institute.service";

export const getInstitute = createAsyncThunk(
  "institute/getInstitute",
  async (payload, thunkAPI) => {
    try {
      const response = await InstituteService.getInstitute(payload);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const addInstitute = createAsyncThunk(
  "institute/addInstitute",
  async (data, thunkAPI) => {
    try {
      const response = await InstituteService.addInstitute(data);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);




const initialState = {
  loading: false,
  error: null,
  instituteList: [],
  updateSuccess: false,
};

/* =================== Slice =================== */

const instituteSlice = createSlice({
  name: "institute",
  initialState,

  reducers: {
    resetUpdateStatus: (state) => {
      state.updateSuccess = false;
    },
  },

  extraReducers: (builder) => {
    builder

      /* ---------- Get diarynote ---------- */
      .addCase(getInstitute.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getInstitute.fulfilled, (state, action) => {
        state.loading = false;
        state.instituteList = action.payload?.data || [];
      })
      .addCase(getInstitute.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* ---------- Add diarynote ---------- */
      .addCase(addInstitute.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addInstitute.fulfilled, (state, action) => {
        state.loading = false;
        state.instituteList.unshift(action.payload?.data);
      })
      .addCase(addInstitute.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export const { resetUpdateStatus } = instituteSlice.actions;
export default instituteSlice.reducer;
